export type Language = 'ar' | 'en' | 'fr';

export const translations: Record<Language, Record<string, string>> = {
  ar: {
    // App
    'app.name': 'Marché DZ',
    'app.welcome': 'أهلاً بك 👋',
    'app.search_placeholder': 'ابحث عن منتجات، متاجر...',
    // Nav
    'nav.home': 'الرئيسية',
    'nav.search': 'البحث',
    'nav.chat': 'المحادثات',
    'nav.cart': 'السلة',
    'nav.profile': 'حسابي',
    // Home
    'home.exclusive': 'عروض حصرية',
    'home.discount_up_to': 'خصم يصل إلى 50%',
    'home.on_products': 'على أكثر من 1000 منتج',
    'home.shop_now': 'تسوق الآن',
    'home.categories': 'التصنيفات',
    'home.featured_stores': 'متاجر مميزة',
    'home.special_offers': '🔥 عروض خاصة',
    'home.new_arrivals': '✨ وصل حديثاً',
    'home.best_sellers': '🔥 الأكثر مبيعاً',
    'home.all_products': 'جميع المنتجات',
    'home.limited': 'عرض محدود',
    // Product
    'product.add_to_cart': 'أضف للسلة',
    'product.color': 'اللون',
    'product.size': 'المقاس',
    'product.description': 'الوصف',
    'product.similar': 'منتجات مشابهة',
    'product.reviews': 'تقييم',
    'product.not_found': 'المنتج غير موجود',
    'product.new': 'جديد',
    'product.hot': '🔥 رائج',
    'product.discount': 'خصم',
    // Cart
    'cart.title': 'سلة المشتريات',
    'cart.product': 'منتج',
    'cart.empty': 'السلة فارغة',
    'cart.empty_desc': 'ابدأ بإضافة منتجات للسلة',
    'cart.browse': 'تصفح المنتجات',
    'cart.subtotal': 'المجموع الفرعي',
    'cart.delivery': 'التوصيل',
    'cart.free': 'مجاني',
    'cart.total': 'الإجمالي',
    'cart.checkout': 'إتمام الطلب',
    // Checkout
    'checkout.title': 'إتمام الطلب',
    'checkout.address': 'عنوان التوصيل',
    'checkout.address_placeholder': 'أدخل عنوانك بالتفصيل (المدينة، الحي، الشارع، رقم المبنى)',
    'checkout.phone': 'رقم الهاتف',
    'checkout.notes': 'ملاحظات (اختياري)',
    'checkout.notes_placeholder': 'أي ملاحظات خاصة بالطلب...',
    'checkout.coupon': 'كوبون خصم',
    'checkout.coupon_placeholder': 'أدخل كود الكوبون',
    'checkout.apply': 'تطبيق',
    'checkout.remove': 'إزالة',
    'checkout.coupon_discount': 'خصم الكوبون',
    'checkout.payment': 'طريقة الدفع',
    'checkout.cod': 'الدفع عند الاستلام (COD)',
    'checkout.summary': 'ملخص الطلب',
    'checkout.confirm': 'تأكيد الطلب',
    'checkout.submitting': 'جارٍ الإرسال...',
    'checkout.success': 'تم تأكيد طلبك!',
    'checkout.order_number': 'رقم الطلب',
    'checkout.will_contact': 'سيتم التواصل معك لتأكيد التوصيل',
    'checkout.back_home': 'العودة للرئيسية',
    'checkout.invalid_coupon': 'كوبون غير صالح',
    'checkout.check_coupon': 'تأكد من صحة كود الكوبون',
    'checkout.expired_coupon': 'الكوبون منتهي الصلاحية',
    'checkout.used_coupon': 'الكوبون استُنفد بالكامل',
    'checkout.min_order': 'لم يتم الوصول للحد الأدنى',
    'checkout.min_amount': 'الحد الأدنى',
    'checkout.coupon_applied': 'تم تطبيق الكوبون!',
    'checkout.error': 'خطأ',
    'checkout.order_error': 'حدث خطأ أثناء إنشاء الطلب',
    // Orders
    'orders.title': 'طلباتي',
    'orders.empty': 'لا توجد طلبات بعد',
    'orders.login_prompt': 'سجل دخولك لعرض طلباتك',
    'orders.rate_driver': 'قيّم المندوب',
    'orders.rated': '✓ تم التقييم',
    'orders.status.pending': 'بانتظار التأكيد',
    'orders.status.confirmed': 'مؤكد',
    'orders.status.preparing': 'قيد التحضير',
    'orders.status.shipping': 'مع المندوب',
    'orders.status.delivered': 'تم التسليم',
    'orders.status.cancelled': 'ملغي',
    // Profile
    'profile.title': 'حسابي',
    'profile.user': 'مستخدم',
    'profile.guest_title': 'مرحباً بك',
    'profile.guest_desc': 'سجل دخولك للاستمتاع بجميع المزايا',
    'profile.login': 'تسجيل الدخول',
    'profile.logout': 'تسجيل الخروج',
    'profile.orders': 'طلباتي',
    'profile.vendor_panel': 'لوحة التاجر',
    'profile.driver_panel': 'لوحة المندوب',
    'profile.addresses': 'عناويني',
    'profile.settings': 'الإعدادات',
    'profile.dark_mode': 'الوضع المظلم',
    'profile.light_mode': 'الوضع الفاتح',
    'profile.language': 'اللغة',
    'profile.currency': 'العملة',
    // Common
    'common.loading': 'جاري التحميل...',
    'common.error': 'خطأ',
    'common.save': 'حفظ',
    'common.cancel': 'إلغاء',
    'common.add': 'إضافة',
    'common.edit': 'تعديل',
    'common.delete': 'حذف',
    'common.confirm': 'تأكيد',
    'common.added': 'تمت الإضافة',
    'common.updated': 'تم التحديث',
    'common.deleted': 'تم الحذف',
    'common.no_data': 'لا توجد بيانات بعد',
    // Admin
    'admin.panel': 'لوحة تحكم المشرف',
    'admin.management': 'الإدارة',
    'admin.overview': 'نظرة عامة',
    'admin.stores': 'التجار',
    'admin.orders': 'الطلبات',
    'admin.categories': 'الفئات',
    'admin.users': 'المستخدمين',
    'admin.drivers': 'المندوبين',
    'admin.reports': 'التقارير',
    'admin.settings': 'الإعدادات',
    'admin.stores_count': 'المتاجر',
    'admin.orders_count': 'الطلبات',
    'admin.products_count': 'المنتجات',
    'admin.users_count': 'المستخدمين',
    'admin.manage_orders': 'إدارة الطلبات',
    'admin.all_orders': 'جميع الطلبات',
    'admin.filter': 'فلترة',
    'admin.no_orders': 'لا توجد طلبات',
    'admin.confirm_order': 'تأكيد',
    'admin.start_preparing': 'بدء التحضير',
    'admin.send_delivery': 'إرسال للتوصيل',
    'admin.mark_delivered': 'تم التسليم',
    'admin.status_updated': 'تم تحديث حالة الطلب إلى',
    'admin.manage_stores': 'إدارة التجار',
    'admin.no_stores': 'لا توجد متاجر مسجلة بعد',
    'admin.verified': 'موثق',
    'admin.active': 'نشط',
    'admin.disabled': 'معطل',
    'admin.no_description': 'بدون وصف',
    'admin.join_date': 'تاريخ الانضمام',
    'admin.disable': 'تعطيل',
    'admin.enable': 'تفعيل',
    'admin.store_disabled': 'تم تعطيل المتجر',
    'admin.store_enabled': 'تم تفعيل المتجر',
    'admin.unverify': 'تم إلغاء التوثيق',
    'admin.verify': 'تم توثيق المتجر',
    'admin.store': 'متجر',
    'admin.no_users': 'لا يوجد مستخدمين',
    'admin.no_name': 'بدون اسم',
    'admin.no_phone': 'بدون هاتف',
    'admin.joined': 'انضم',
    'admin.customer': 'عميل',
    'admin.manage_categories': 'إدارة الفئات',
    'admin.icon_placeholder': 'الأيقونة (إيموجي)',
    'admin.new_category': 'اسم الفئة الجديدة',
    'admin.no_categories': 'لا توجد فئات',
    'admin.manage_drivers': 'إدارة المندوبين',
    'admin.no_drivers': 'لا يوجد مندوبين مسجلين بعد',
    'admin.delivery_count': 'توصيلة',
    'admin.activated': 'مفعّل',
    'admin.suspended': 'معلّق',
    'admin.driver_disabled': 'تم تعطيل المندوب',
    'admin.driver_enabled': 'تم تفعيل المندوب',
    'admin.reports_stats': 'التقارير والإحصائيات',
    'admin.total_revenue': 'إجمالي الإيرادات',
    'admin.total_orders': 'إجمالي الطلبات',
    'admin.completed_orders': 'طلبات مكتملة',
    'admin.delivery_fees': 'رسوم التوصيل',
    'admin.monthly_sales': 'المبيعات الشهرية',
    'admin.order_statuses': 'حالات الطلبات',
    'admin.daily_orders': 'الطلبات اليومية (آخر 30 يوم)',
    'admin.performance': 'ملخص الأداء',
    'admin.completion_rate': 'نسبة الإكمال',
    'admin.cancellation_rate': 'نسبة الإلغاء',
    'admin.avg_order': 'متوسط قيمة الطلب',
    'admin.print_pdf': 'طباعة PDF',
    'admin.admin_report': 'تقرير المشرف',
    'admin.general_settings': 'الإعدادات العامة',
    'admin.commissions': 'العمولات',
    'admin.default_commission': 'نسبة العمولة الافتراضية (%)',
    'admin.delivery_section': 'التوصيل',
    'admin.delivery_fee': 'رسوم التوصيل',
    'admin.free_delivery_min': 'الحد الأدنى للتوصيل المجاني',
    'admin.cod_section': 'الدفع عند الاستلام',
    'admin.max_cod': 'الحد الأقصى لقيمة الطلب',
    'admin.save_settings': 'حفظ الإعدادات',
    'admin.settings_saved': 'تم حفظ الإعدادات بنجاح',
    'admin.sales': 'المبيعات',
    'admin.order_count': 'عدد الطلبات',
    // Vendor
    'vendor.panel': 'لوحة تحكم التاجر',
    'vendor.store_management': 'إدارة المتجر',
    'vendor.overview': 'نظرة عامة',
    'vendor.products': 'المنتجات',
    'vendor.orders': 'الطلبات',
    'vendor.store': 'المتجر',
    'vendor.chat': 'المحادثات',
    'vendor.coupons': 'الكوبونات',
    'vendor.stats': 'الإحصائيات',
    'vendor.finance': 'المالية',
    'vendor.settings': 'الإعدادات',
    'vendor.no_store': 'لم يتم إنشاء متجر بعد',
    'vendor.contact_admin': 'يرجى التواصل مع المشرف',
    'vendor.under_review': 'متجرك قيد المراجعة',
    'vendor.will_activate': 'سيتم تفعيل متجرك بعد موافقة المشرف',
    'vendor.total_products': 'المنتجات',
    'vendor.total_orders': 'إجمالي الطلبات',
    'vendor.new_orders': 'طلبات جديدة',
    'vendor.store_info': 'معلومات المتجر',
    'vendor.store_name': 'اسم المتجر',
    'vendor.status': 'الحالة',
    'vendor.rating': 'التقييم',
    'vendor.active': 'نشط',
    'vendor.under_review_badge': 'قيد المراجعة',
    'vendor.no_store_found': 'لا يوجد متجر',
    'vendor.confirm_order': 'تأكيد الطلب',
    'vendor.start_preparing': 'بدء التحضير',
    'vendor.ready_ship': 'جاهز للشحن',
    'vendor.status_updated': 'تم تحديث حالة الطلب',
    'vendor.no_orders': 'لا توجد طلبات بعد',
    'vendor.add_product': 'إضافة منتج',
    'vendor.edit_product': 'تعديل المنتج',
    'vendor.add_new_product': 'إضافة منتج جديد',
    'vendor.product_name': 'اسم المنتج',
    'vendor.description': 'الوصف',
    'vendor.product_desc': 'وصف المنتج',
    'vendor.price': 'السعر',
    'vendor.old_price': 'السعر القديم',
    'vendor.stock': 'المخزون',
    'vendor.category': 'الفئة',
    'vendor.choose': 'اختر',
    'vendor.product_status': 'الحالة',
    'vendor.available': 'متاح',
    'vendor.out_of_stock': 'نفذت الكمية',
    'vendor.hidden': 'مخفي',
    'vendor.badge': 'شارة',
    'vendor.none': 'بدون',
    'vendor.new': 'جديد',
    'vendor.sale': 'تخفيض',
    'vendor.hot': 'رائج',
    'vendor.colors': 'الألوان (مفصولة بفاصلة)',
    'vendor.sizes': 'المقاسات (مفصولة بفاصلة)',
    'vendor.save_changes': 'حفظ التعديلات',
    'vendor.add_product_btn': 'إضافة المنتج',
    'vendor.no_products': 'لا توجد منتجات بعد',
    'vendor.first_product': 'أضف أول منتج لمتجرك',
    'vendor.no_description': 'بدون وصف',
    'vendor.product_deleted': 'تم حذف المنتج',
    'vendor.store_settings': 'إعدادات المتجر',
    'vendor.store_description': 'وصف المتجر',
    'vendor.phone': 'رقم الهاتف',
    'vendor.address': 'العنوان',
    'vendor.saved': 'تم حفظ التعديلات',
    'vendor.finance_title': 'المالية',
    'vendor.transactions_here': 'سجل المعاملات سيظهر هنا',
    'vendor.after_first_order': 'بعد إتمام أول طلب',
    'vendor.discount_coupons': 'كوبونات الخصم',
    'vendor.add_coupon': 'إضافة كوبون',
    'vendor.edit_coupon': 'تعديل الكوبون',
    'vendor.new_coupon': 'إنشاء كوبون جديد',
    'vendor.coupon_code': 'كود الكوبون',
    'vendor.coupon_desc': 'الوصف (اختياري)',
    'vendor.discount_type': 'نوع الخصم',
    'vendor.percentage': 'نسبة مئوية %',
    'vendor.fixed_amount': 'مبلغ ثابت',
    'vendor.discount_value': 'قيمة الخصم',
    'vendor.min_order': 'الحد الأدنى للطلب',
    'vendor.max_uses': 'عدد الاستخدامات',
    'vendor.unlimited': 'غير محدود',
    'vendor.expiry_date': 'تاريخ الانتهاء (اختياري)',
    'vendor.create': 'إنشاء',
    'vendor.update': 'تحديث',
    'vendor.no_coupons': 'لا توجد كوبونات بعد',
    'vendor.coupon_active': 'نشط',
    'vendor.coupon_expired': 'منتهي',
    'vendor.coupon_paused': 'متوقف',
    'vendor.discount': 'الخصم',
    'vendor.min_order_label': 'الحد الأدنى',
    'vendor.usage': 'الاستخدام',
    'vendor.expires': 'ينتهي',
    'vendor.coupon_updated': 'تم تحديث الكوبون',
    'vendor.coupon_created': 'تم إنشاء الكوبون',
    'vendor.coupon_deleted': 'تم حذف الكوبون',
    'vendor.code_copied': 'تم نسخ الكود',
    'vendor.total_revenue': 'إجمالي الإيرادات',
    'vendor.recent_orders': 'آخر الطلبات',
    'vendor.no_orders_yet': 'لا توجد طلبات بعد',
    'vendor.stock_alerts': 'تنبيهات المخزون',
    'vendor.stock_good': '✅ المخزون بحالة جيدة',
    'vendor.needs_attention': '⚠️ تحتاج انتباهك',
    'vendor.out_of_stock_label': 'نفد',
    'vendor.remaining': 'متبقي',
    'vendor.active_orders': 'طلبات نشطة',
    'vendor.monthly_sales': 'المبيعات الشهرية',
    'vendor.order_statuses': 'حالات الطلبات',
    'vendor.daily_orders': 'الطلبات اليومية (آخر 30 يوم)',
    'vendor.performance': 'ملخص الأداء',
    'vendor.completion_rate': 'نسبة الإكمال',
    'vendor.cancellation_rate': 'نسبة الإلغاء',
    'vendor.avg_order': 'متوسط قيمة الطلب',
    'vendor.store_report': 'تقرير المتجر',
    'vendor.store_not_found': 'لم يتم العثور على متجرك',
    'vendor.customer_chats': 'محادثات العملاء',
    'vendor.customer': 'عميل',
    'vendor.settings_extra': 'إعدادات إضافية قريباً',
    'vendor.sales': 'المبيعات',
    'vendor.order_count': 'عدد الطلبات',
    'vendor.search_orders': '🔍 بحث برقم الطلب أو الهاتف...',
    'vendor.processing': 'قيد المعالجة',
    'vendor.in_transit': 'في الطريق',
    'vendor.completed': 'مكتملة',
    'vendor.no_processing_orders': 'لا توجد طلبات قيد المعالجة',
    'vendor.no_transit_orders': 'لا توجد طلبات في الطريق',
    'vendor.no_completed_orders': 'لا توجد طلبات مكتملة',
    'vendor.awaiting_confirmation': '⏳ بانتظار تأكيد الاستلام من الزبون',
    'vendor.rate_customer': 'تقييم العميل',
    'vendor.customer_rated': '✓ تم تقييم العميل',
    'vendor.hide_products': 'إخفاء المنتجات',
    'vendor.show_products': 'عرض المنتجات المطلوبة',
    'vendor.product_item': 'منتج',
    'vendor.quantity': 'الكمية',
    'vendor.size_label': 'المقاس',
    'vendor.color_label': 'اللون',
    'vendor.uploading': 'جاري الرفع...',
    'vendor.no_results': 'لا توجد نتائج',
    'vendor.search_products': '🔍 بحث في المنتجات...',
    // Orders - confirm delivery
    'orders.confirm_delivery': 'تأكيد الاستلام',
    'orders.confirming': 'جاري التأكيد...',
    'orders.confirm_title': 'تأكيد استلام الطلب',
    'orders.confirm_desc': 'هل تؤكد أنك استلمت الطلب #{id}؟ بعد التأكيد لا يمكن التراجع عن هذا الإجراء.',
    'orders.confirmed_success': '✅ تم تأكيد الاستلام',
    'orders.confirmed_desc': 'شكراً لتأكيدك استلام الطلب',
    'orders.yes_received': 'نعم، تم الاستلام',
    // Auth
    'auth.login_title': 'مرحباً بعودتك 👋',
    'auth.login_subtitle': 'سجل دخولك للمتابعة',
    'auth.email': 'البريد الإلكتروني',
    'auth.password': 'كلمة المرور',
    'auth.forgot_password': 'نسيت كلمة المرور؟',
    'auth.remember_me': 'تذكرني',
    'auth.logging_in': 'جاري تسجيل الدخول...',
    'auth.login': 'تسجيل الدخول',
    'auth.no_account': 'ليس لديك حساب؟',
    'auth.create_account': 'إنشاء حساب',
    'auth.login_error': 'خطأ في تسجيل الدخول',
    'auth.register_title': 'إنشاء حساب جديد ✨',
    'auth.register_subtitle': 'سجل الآن وابدأ التسوق',
    'auth.full_name': 'الاسم الكامل',
    'auth.password_hint': 'كلمة المرور (6 أحرف على الأقل)',
    'auth.creating_account': 'جاري إنشاء الحساب...',
    'auth.register': 'إنشاء حساب',
    'auth.have_account': 'لديك حساب بالفعل؟',
    'auth.register_error': 'خطأ في التسجيل',
    'auth.register_success': 'تم التسجيل بنجاح!',
    'auth.verify_email': 'يرجى التحقق من بريدك الإلكتروني لتأكيد الحساب',
    'auth.password_min': 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
    'auth.forgot_title': 'استعادة كلمة المرور 🔑',
    'auth.forgot_subtitle': 'أدخل بريدك الإلكتروني وسنرسل لك رابط الاستعادة',
    'auth.forgot_phone_subtitle': 'أدخل رقم هاتفك وسنرسل لك رمز التحقق',
    'auth.via_email': 'عبر البريد',
    'auth.via_phone': 'عبر الهاتف',
    'auth.phone_number': 'رقم الهاتف',
    'auth.send_otp': 'إرسال رمز التحقق',
    'auth.otp_sent': 'تم إرسال رمز التحقق',
    'auth.check_phone': 'تحقق من رسائل هاتفك',
    'auth.enter_otp': 'أدخل رمز التحقق',
    'auth.verify_otp': 'تحقق من الرمز',
    'auth.verifying': 'جاري التحقق...',
    'auth.otp_verified': 'تم التحقق بنجاح!',
    'auth.invalid_otp': 'رمز التحقق غير صحيح',
    'auth.sending': 'جاري الإرسال...',
    'auth.send_reset': 'إرسال رابط الاستعادة',
    'auth.back_to_login': 'العودة لتسجيل الدخول',
    'auth.reset_sent': 'تم إرسال رابط الاستعادة',
    'auth.check_email': 'تحقق من بريدك الإلكتروني',
    'auth.reset_title': 'كلمة مرور جديدة 🔐',
    'auth.reset_subtitle': 'أدخل كلمة المرور الجديدة',
    'auth.new_password': 'كلمة المرور الجديدة',
    'auth.updating': 'جاري التحديث...',
    'auth.update_password': 'تحديث كلمة المرور',
    'auth.password_updated': 'تم تحديث كلمة المرور بنجاح!',
    // Chat
    'chat.title': 'المحادثات',
    'chat.login_prompt': 'سجل دخولك لعرض المحادثات',
    'chat.no_conversations': 'لا توجد محادثات بعد',
    'chat.store': 'متجر',
    'chat.customer': 'عميل',
    'chat.new_conversation': 'محادثة جديدة',
    'chat.start_conversation': 'ابدأ المحادثة...',
    'chat.write_message': 'اكتب رسالة...',
    // Search
    'search.search_in': 'بحث في {name}...',
    'search.search_products': 'ابحث عن منتجات...',
    'search.browse_by_category': 'تصفح حسب الفئة',
    'search.results_count': '{count} نتيجة',
    'search.no_results': 'لا توجد نتائج',
    // Review
    'review.rate_driver': 'قيّم المندوب',
    'review.already_reviewed': 'تم التقييم مسبقاً',
    'review.already_reviewed_desc': 'لقد قمت بتقييم هذا الطلب بالفعل',
    'review.thanks': 'شكراً لتقييمك! ⭐',
    'review.add_comment': 'أضف تعليقاً (اختياري)...',
    'review.submitting': 'جارٍ الإرسال...',
    'review.submit': 'إرسال التقييم',
    'review.bad': 'سيء',
    'review.acceptable': 'مقبول',
    'review.good': 'جيد',
    'review.very_good': 'جيد جداً',
    'review.excellent': 'ممتاز',
    'review.rate_customer': 'تقييم العميل',
    'review.comment_placeholder': 'تعليق (اختياري)...',
    'review.sending': 'إرسال...',
    'review.send': 'إرسال التقييم',
    'review.sent_success': 'تم إرسال التقييم بنجاح!',
    // Services Admin
    'admin.services': 'الخدمات',
    'admin.manage_services': 'إدارة الخدمات',
    'admin.service_approved': 'تمت الموافقة على الخدمة ✅',
    'admin.service_rejected': 'تم رفض الخدمة ❌',
    'admin.service_disabled': 'تم تعطيل الخدمة',
    'admin.service_enabled': 'تم تفعيل الخدمة',
    'admin.approved_badge': 'مُوافق',
    'admin.pending_approval': 'بانتظار الموافقة',
    'admin.approve': 'موافقة',
    'admin.reject': 'رفض',
    'admin.service_provider': 'مقدم الخدمة',
    'admin.phone_label': 'الهاتف',
    'admin.city_label': 'المدينة',
    'admin.request_date': 'تاريخ الطلب',
    'admin.no_pending_services': 'لا توجد طلبات معلقة',
    'admin.no_services': 'لا توجد خدمات',
    'admin.approved_services': 'المُوافق عليها',
    'admin.store_approved': 'تمت الموافقة على المتجر ✅',
    'admin.store_rejected': 'تم رفض المتجر ❌',
    'admin.pending_stores': 'طلبات معلقة',
    'admin.active_stores': 'المتاجر النشطة',
    'admin.no_pending_stores': 'لا توجد طلبات معلقة',
    'admin.approve_store': 'موافقة',
    'admin.reject_store': 'رفض',
    'admin.awaiting_approval': 'بانتظار الموافقة',
    'admin.role_admin': 'مشرف',
    'admin.role_vendor': 'تاجر',
    'admin.role_driver': 'سائق',
    'admin.role_customer': 'عميل',
    'admin.role_add_error': 'فشل في إضافة الدور',
    'admin.role_remove_error': 'فشل في إزالة الدور',
    'admin.role_added': 'تم إضافة الدور',
    'admin.role_removed': 'تم إزالة الدور',
    'admin.remove_role': 'إزالة دور',
    // Notifications
    'notification.new_order': '🔔 طلب جديد!',
    'notification.new_order_desc': 'طلب جديد بقيمة {amount} - #{id}',
    'notification.delivery_confirmed': '✅ تم تأكيد استلام الطلب من الزبون',
    'notification.order_cancelled': '❌ تم إلغاء الطلب',
    'notification.order_id': 'الطلب #{id}',
    // Product badges
    'product.free_delivery': 'توصيل سريع',
    'product.guarantee': 'ضمان الجودة',
    'product.return_policy': 'إرجاع مجاني',
    // Profile
    'profile.admin_panel': 'لوحة الإشراف',
    // Services
    'service.propose': 'عرض خدمة',
    'service.title_label': 'عنوان الخدمة',
    'service.title_placeholder': 'مثال: سباك محترف للمنازل',
    'service.category': 'التصنيف',
    'service.choose_category': 'اختر تصنيفاً',
    'service.description': 'الوصف',
    'service.description_placeholder': 'صف خدمتك بالتفصيل...',
    'service.images': 'صور الخدمة',
    'service.images_hint': 'يمكنك رفع حتى 5 صور',
    'service.provider_name': 'اسمك',
    'service.provider_name_placeholder': 'الاسم الكامل أو اسم المؤسسة',
    'service.phone': 'رقم الهاتف',
    'service.phone_placeholder': '0555 123 456',
    'service.whatsapp': 'رقم واتساب',
    'service.whatsapp_placeholder': '0555 123 456',
    'service.wilaya': 'الولاية',
    'service.choose_wilaya': 'اختر الولاية',
    'service.city': 'المدينة / البلدية',
    'service.city_placeholder': 'مثال: باب الواد، وهران...',
    'service.address': 'العنوان',
    'service.address_placeholder': 'العنوان بالتفصيل',
    'service.price_type': 'نوع التسعير',
    'service.negotiable': 'حسب الطلب',
    'service.fixed': 'سعر ثابت',
    'service.hourly': 'بالساعة',
    'service.price': 'السعر (د.ج)',
    'service.experience': 'سنوات الخبرة',
    'service.experience_placeholder': 'مثال: 5',
    'service.availability': 'التوفر',
    'service.available': 'متوفر',
    'service.busy': 'مشغول',
    'service.unavailable': 'غير متوفر',
    'service.work_hours': 'أوقات العمل',
    'service.work_hours_placeholder': 'مثال: 08:00 - 17:00',
    'service.submit': 'نشر الخدمة',
    'service.submitting': 'جارٍ الإرسال...',
    'service.required_fields': 'يرجى ملء الحقول المطلوبة',
    'service.success': 'تم إرسال الخدمة! ستظهر بعد موافقة المشرف.',
    'service.approval_banner': 'ستظهر خدمتك بعد موافقة المشرف.',
    'service.pending': 'بانتظار الموافقة',
    'service.provider': 'مقدم الخدمة',
    'service.not_found': 'الخدمة غير موجودة',
    'service.back': 'رجوع',
    'service.call': 'اتصل',
    'service.on_quote': 'حسب الطلب',
    'service.per_hour': '/ساعة',
    'service.reviews': 'التقييمات',
    'service.login_to_review': 'سجل دخولك لترك تقييم',
    'service.login': 'تسجيل الدخول',
    'service.already_reviewed': 'لقد قمت بتقييم هذه الخدمة',
    'service.give_review': 'أعطِ تقييمك',
    'service.your_comment': 'تعليقك...',
    'service.send': 'إرسال',
    'service.sending': 'إرسال...',
    'service.review_success': 'شكراً لتقييمك!',
    'service.years_exp': 'سنوات خبرة',
    'service.distinguished': 'حرفي متميز',
    'service.work_schedule': 'أوقات العمل',
  },
  en: {
    'app.name': 'Marché DZ',
    'app.welcome': 'Welcome 👋',
    'app.search_placeholder': 'Search products, stores...',
    'nav.home': 'Home',
    'nav.search': 'Search',
    'nav.chat': 'Chat',
    'nav.cart': 'Cart',
    'nav.profile': 'Profile',
    'home.exclusive': 'Exclusive Deals',
    'home.discount_up_to': 'Up to 50% Off',
    'home.on_products': 'On over 1000 products',
    'home.shop_now': 'Shop Now',
    'home.categories': 'Categories',
    'home.featured_stores': 'Featured Stores',
    'home.special_offers': '🔥 Special Offers',
    'home.new_arrivals': '✨ New Arrivals',
    'home.best_sellers': '🔥 Best Sellers',
    'home.all_products': 'All Products',
    'home.limited': 'Limited Offer',
    'product.add_to_cart': 'Add to Cart',
    'product.color': 'Color',
    'product.size': 'Size',
    'product.description': 'Description',
    'product.similar': 'Similar Products',
    'product.reviews': 'reviews',
    'product.not_found': 'Product not found',
    'product.new': 'New',
    'product.hot': '🔥 Hot',
    'product.discount': 'Off',
    'cart.title': 'Shopping Cart',
    'cart.product': 'item',
    'cart.empty': 'Cart is Empty',
    'cart.empty_desc': 'Start adding products to your cart',
    'cart.browse': 'Browse Products',
    'cart.subtotal': 'Subtotal',
    'cart.delivery': 'Delivery',
    'cart.free': 'Free',
    'cart.total': 'Total',
    'cart.checkout': 'Checkout',
    'checkout.title': 'Checkout',
    'checkout.address': 'Delivery Address',
    'checkout.address_placeholder': 'Enter your full address (city, district, street, building)',
    'checkout.phone': 'Phone Number',
    'checkout.notes': 'Notes (optional)',
    'checkout.notes_placeholder': 'Any special notes for the order...',
    'checkout.coupon': 'Coupon Code',
    'checkout.coupon_placeholder': 'Enter coupon code',
    'checkout.apply': 'Apply',
    'checkout.remove': 'Remove',
    'checkout.coupon_discount': 'Coupon Discount',
    'checkout.payment': 'Payment Method',
    'checkout.cod': 'Cash on Delivery (COD)',
    'checkout.summary': 'Order Summary',
    'checkout.confirm': 'Confirm Order',
    'checkout.submitting': 'Submitting...',
    'checkout.success': 'Order Confirmed!',
    'checkout.order_number': 'Order #',
    'checkout.will_contact': 'We will contact you to confirm delivery',
    'checkout.back_home': 'Back to Home',
    'checkout.invalid_coupon': 'Invalid Coupon',
    'checkout.check_coupon': 'Check the coupon code',
    'checkout.expired_coupon': 'Coupon Expired',
    'checkout.used_coupon': 'Coupon Fully Used',
    'checkout.min_order': 'Minimum not reached',
    'checkout.min_amount': 'Minimum',
    'checkout.coupon_applied': 'Coupon Applied!',
    'checkout.error': 'Error',
    'checkout.order_error': 'An error occurred while creating the order',
    'orders.title': 'My Orders',
    'orders.empty': 'No orders yet',
    'orders.login_prompt': 'Login to view your orders',
    'orders.rate_driver': 'Rate Driver',
    'orders.rated': '✓ Rated',
    'orders.status.pending': 'Pending',
    'orders.status.confirmed': 'Confirmed',
    'orders.status.preparing': 'Preparing',
    'orders.status.shipping': 'Shipping',
    'orders.status.delivered': 'Delivered',
    'orders.status.cancelled': 'Cancelled',
    'profile.title': 'My Account',
    'profile.user': 'User',
    'profile.guest_title': 'Welcome',
    'profile.guest_desc': 'Login to enjoy all features',
    'profile.login': 'Login',
    'profile.logout': 'Logout',
    'profile.orders': 'My Orders',
    'profile.vendor_panel': 'Vendor Panel',
    'profile.driver_panel': 'Driver Panel',
    'profile.addresses': 'My Addresses',
    'profile.settings': 'Settings',
    'profile.dark_mode': 'Dark Mode',
    'profile.light_mode': 'Light Mode',
    'profile.language': 'Language',
    'profile.currency': 'Currency',
    // Common
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.add': 'Add',
    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.confirm': 'Confirm',
    'common.added': 'Added',
    'common.updated': 'Updated',
    'common.deleted': 'Deleted',
    'common.no_data': 'No data yet',
    // Admin
    'admin.panel': 'Admin Panel',
    'admin.management': 'Management',
    'admin.overview': 'Overview',
    'admin.stores': 'Stores',
    'admin.orders': 'Orders',
    'admin.categories': 'Categories',
    'admin.users': 'Users',
    'admin.drivers': 'Drivers',
    'admin.reports': 'Reports',
    'admin.settings': 'Settings',
    'admin.stores_count': 'Stores',
    'admin.orders_count': 'Orders',
    'admin.products_count': 'Products',
    'admin.users_count': 'Users',
    'admin.manage_orders': 'Manage Orders',
    'admin.all_orders': 'All Orders',
    'admin.filter': 'Filter',
    'admin.no_orders': 'No orders',
    'admin.confirm_order': 'Confirm',
    'admin.start_preparing': 'Start Preparing',
    'admin.send_delivery': 'Send for Delivery',
    'admin.mark_delivered': 'Delivered',
    'admin.status_updated': 'Order status updated to',
    'admin.manage_stores': 'Manage Stores',
    'admin.no_stores': 'No stores registered yet',
    'admin.verified': 'Verified',
    'admin.active': 'Active',
    'admin.disabled': 'Disabled',
    'admin.no_description': 'No description',
    'admin.join_date': 'Join Date',
    'admin.disable': 'Disable',
    'admin.enable': 'Enable',
    'admin.store_disabled': 'Store disabled',
    'admin.store_enabled': 'Store enabled',
    'admin.unverify': 'Verification removed',
    'admin.verify': 'Store verified',
    'admin.store': 'Store',
    'admin.no_users': 'No users',
    'admin.no_name': 'No name',
    'admin.no_phone': 'No phone',
    'admin.joined': 'Joined',
    'admin.customer': 'Customer',
    'admin.manage_categories': 'Manage Categories',
    'admin.icon_placeholder': 'Icon (emoji)',
    'admin.new_category': 'New category name',
    'admin.no_categories': 'No categories',
    'admin.manage_drivers': 'Manage Drivers',
    'admin.no_drivers': 'No drivers registered yet',
    'admin.delivery_count': 'delivery',
    'admin.activated': 'Active',
    'admin.suspended': 'Suspended',
    'admin.driver_disabled': 'Driver disabled',
    'admin.driver_enabled': 'Driver enabled',
    'admin.reports_stats': 'Reports & Statistics',
    'admin.total_revenue': 'Total Revenue',
    'admin.total_orders': 'Total Orders',
    'admin.completed_orders': 'Completed Orders',
    'admin.delivery_fees': 'Delivery Fees',
    'admin.monthly_sales': 'Monthly Sales',
    'admin.order_statuses': 'Order Statuses',
    'admin.daily_orders': 'Daily Orders (Last 30 days)',
    'admin.performance': 'Performance Summary',
    'admin.completion_rate': 'Completion Rate',
    'admin.cancellation_rate': 'Cancellation Rate',
    'admin.avg_order': 'Avg Order Value',
    'admin.print_pdf': 'Print PDF',
    'admin.admin_report': 'Admin Report',
    'admin.general_settings': 'General Settings',
    'admin.commissions': 'Commissions',
    'admin.default_commission': 'Default Commission (%)',
    'admin.delivery_section': 'Delivery',
    'admin.delivery_fee': 'Delivery Fee',
    'admin.free_delivery_min': 'Free Delivery Minimum',
    'admin.cod_section': 'Cash on Delivery',
    'admin.max_cod': 'Max Order Value',
    'admin.save_settings': 'Save Settings',
    'admin.settings_saved': 'Settings saved successfully',
    'admin.sales': 'Sales',
    'admin.order_count': 'Order Count',
    // Vendor
    'vendor.panel': 'Vendor Panel',
    'vendor.store_management': 'Store Management',
    'vendor.overview': 'Overview',
    'vendor.products': 'Products',
    'vendor.orders': 'Orders',
    'vendor.store': 'Store',
    'vendor.chat': 'Chat',
    'vendor.coupons': 'Coupons',
    'vendor.stats': 'Statistics',
    'vendor.finance': 'Finance',
    'vendor.settings': 'Settings',
    'vendor.no_store': 'No store created yet',
    'vendor.contact_admin': 'Please contact admin',
    'vendor.under_review': 'Your store is under review',
    'vendor.will_activate': 'Will be activated after admin approval',
    'vendor.total_products': 'Products',
    'vendor.total_orders': 'Total Orders',
    'vendor.new_orders': 'New Orders',
    'vendor.store_info': 'Store Info',
    'vendor.store_name': 'Store Name',
    'vendor.status': 'Status',
    'vendor.rating': 'Rating',
    'vendor.active': 'Active',
    'vendor.under_review_badge': 'Under Review',
    'vendor.no_store_found': 'No store',
    'vendor.confirm_order': 'Confirm Order',
    'vendor.start_preparing': 'Start Preparing',
    'vendor.ready_ship': 'Ready to Ship',
    'vendor.status_updated': 'Order status updated',
    'vendor.no_orders': 'No orders yet',
    'vendor.add_product': 'Add Product',
    'vendor.edit_product': 'Edit Product',
    'vendor.add_new_product': 'Add New Product',
    'vendor.product_name': 'Product Name',
    'vendor.description': 'Description',
    'vendor.product_desc': 'Product description',
    'vendor.price': 'Price',
    'vendor.old_price': 'Old Price',
    'vendor.stock': 'Stock',
    'vendor.category': 'Category',
    'vendor.choose': 'Choose',
    'vendor.product_status': 'Status',
    'vendor.available': 'Available',
    'vendor.out_of_stock': 'Out of Stock',
    'vendor.hidden': 'Hidden',
    'vendor.badge': 'Badge',
    'vendor.none': 'None',
    'vendor.new': 'New',
    'vendor.sale': 'Sale',
    'vendor.hot': 'Hot',
    'vendor.colors': 'Colors (comma separated)',
    'vendor.sizes': 'Sizes (comma separated)',
    'vendor.save_changes': 'Save Changes',
    'vendor.add_product_btn': 'Add Product',
    'vendor.no_products': 'No products yet',
    'vendor.first_product': 'Add your first product',
    'vendor.no_description': 'No description',
    'vendor.product_deleted': 'Product deleted',
    'vendor.store_settings': 'Store Settings',
    'vendor.store_description': 'Store Description',
    'vendor.phone': 'Phone Number',
    'vendor.address': 'Address',
    'vendor.saved': 'Changes saved',
    'vendor.finance_title': 'Finance',
    'vendor.transactions_here': 'Transaction history will appear here',
    'vendor.after_first_order': 'After completing first order',
    'vendor.discount_coupons': 'Discount Coupons',
    'vendor.add_coupon': 'Add Coupon',
    'vendor.edit_coupon': 'Edit Coupon',
    'vendor.new_coupon': 'Create New Coupon',
    'vendor.coupon_code': 'Coupon Code',
    'vendor.coupon_desc': 'Description (optional)',
    'vendor.discount_type': 'Discount Type',
    'vendor.percentage': 'Percentage %',
    'vendor.fixed_amount': 'Fixed Amount',
    'vendor.discount_value': 'Discount Value',
    'vendor.min_order': 'Minimum Order',
    'vendor.max_uses': 'Max Uses',
    'vendor.unlimited': 'Unlimited',
    'vendor.expiry_date': 'Expiry Date (optional)',
    'vendor.create': 'Create',
    'vendor.update': 'Update',
    'vendor.no_coupons': 'No coupons yet',
    'vendor.coupon_active': 'Active',
    'vendor.coupon_expired': 'Expired',
    'vendor.coupon_paused': 'Paused',
    'vendor.discount': 'Discount',
    'vendor.min_order_label': 'Minimum',
    'vendor.usage': 'Usage',
    'vendor.expires': 'Expires',
    'vendor.coupon_updated': 'Coupon updated',
    'vendor.coupon_created': 'Coupon created',
    'vendor.coupon_deleted': 'Coupon deleted',
    'vendor.code_copied': 'Code copied',
    'vendor.total_revenue': 'Total Revenue',
    'vendor.recent_orders': 'Recent Orders',
    'vendor.no_orders_yet': 'No orders yet',
    'vendor.stock_alerts': 'Stock Alerts',
    'vendor.stock_good': '✅ Stock is in good condition',
    'vendor.needs_attention': '⚠️ Needs your attention',
    'vendor.out_of_stock_label': 'Out',
    'vendor.remaining': 'remaining',
    'vendor.active_orders': 'Active Orders',
    'vendor.monthly_sales': 'Monthly Sales',
    'vendor.order_statuses': 'Order Statuses',
    'vendor.daily_orders': 'Daily Orders (Last 30 days)',
    'vendor.performance': 'Performance Summary',
    'vendor.completion_rate': 'Completion Rate',
    'vendor.cancellation_rate': 'Cancellation Rate',
    'vendor.avg_order': 'Avg Order Value',
    'vendor.store_report': 'Store Report',
    'vendor.store_not_found': 'Store not found',
    'vendor.customer_chats': 'Customer Chats',
    'vendor.customer': 'Customer',
    'vendor.settings_extra': 'Additional settings coming soon',
    'vendor.sales': 'Sales',
    'vendor.order_count': 'Order Count',
    'vendor.search_orders': '🔍 Search by order # or phone...',
    'vendor.processing': 'Processing',
    'vendor.in_transit': 'In Transit',
    'vendor.completed': 'Completed',
    'vendor.no_processing_orders': 'No processing orders',
    'vendor.no_transit_orders': 'No orders in transit',
    'vendor.no_completed_orders': 'No completed orders',
    'vendor.awaiting_confirmation': '⏳ Awaiting customer delivery confirmation',
    'vendor.rate_customer': 'Rate Customer',
    'vendor.customer_rated': '✓ Customer rated',
    'vendor.hide_products': 'Hide products',
    'vendor.show_products': 'Show ordered products',
    'vendor.product_item': 'Product',
    'vendor.quantity': 'Qty',
    'vendor.size_label': 'Size',
    'vendor.color_label': 'Color',
    'vendor.uploading': 'Uploading...',
    'vendor.no_results': 'No results',
    'vendor.search_products': '🔍 Search products...',
    'orders.confirm_delivery': 'Confirm Delivery',
    'orders.confirming': 'Confirming...',
    'orders.confirm_title': 'Confirm Order Receipt',
    'orders.confirm_desc': 'Do you confirm receiving order #{id}? This action cannot be undone.',
    'orders.confirmed_success': '✅ Delivery Confirmed',
    'orders.confirmed_desc': 'Thank you for confirming your order',
    'orders.yes_received': 'Yes, Received',
    'auth.login_title': 'Welcome Back 👋',
    'auth.login_subtitle': 'Sign in to continue',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.forgot_password': 'Forgot password?',
    'auth.remember_me': 'Remember me',
    'auth.logging_in': 'Signing in...',
    'auth.login': 'Sign In',
    'auth.no_account': "Don't have an account?",
    'auth.create_account': 'Create Account',
    'auth.login_error': 'Login Error',
    'auth.register_title': 'Create New Account ✨',
    'auth.register_subtitle': 'Register now and start shopping',
    'auth.full_name': 'Full Name',
    'auth.password_hint': 'Password (at least 6 characters)',
    'auth.creating_account': 'Creating account...',
    'auth.register': 'Create Account',
    'auth.have_account': 'Already have an account?',
    'auth.register_error': 'Registration Error',
    'auth.register_success': 'Registration Successful!',
    'auth.verify_email': 'Please verify your email to confirm your account',
    'auth.password_min': 'Password must be at least 6 characters',
    'auth.forgot_title': 'Reset Password 🔑',
    'auth.forgot_subtitle': 'Enter your email and we\'ll send you a reset link',
    'auth.forgot_phone_subtitle': 'Enter your phone number and we\'ll send you a verification code',
    'auth.via_email': 'Via Email',
    'auth.via_phone': 'Via Phone',
    'auth.phone_number': 'Phone Number',
    'auth.send_otp': 'Send Verification Code',
    'auth.otp_sent': 'Verification Code Sent',
    'auth.check_phone': 'Check your phone messages',
    'auth.enter_otp': 'Enter verification code',
    'auth.verify_otp': 'Verify Code',
    'auth.verifying': 'Verifying...',
    'auth.otp_verified': 'Verified successfully!',
    'auth.invalid_otp': 'Invalid verification code',
    'auth.sending': 'Sending...',
    'auth.send_reset': 'Send Reset Link',
    'auth.back_to_login': 'Back to Login',
    'auth.reset_sent': 'Reset Link Sent',
    'auth.check_email': 'Check your email',
    'auth.reset_title': 'New Password 🔐',
    'auth.reset_subtitle': 'Enter your new password',
    'auth.new_password': 'New Password',
    'auth.updating': 'Updating...',
    'auth.update_password': 'Update Password',
    'auth.password_updated': 'Password updated successfully!',
    'chat.title': 'Messages',
    'chat.login_prompt': 'Sign in to view messages',
    'chat.no_conversations': 'No conversations yet',
    'chat.store': 'Store',
    'chat.customer': 'Customer',
    'chat.new_conversation': 'New conversation',
    'chat.start_conversation': 'Start the conversation...',
    'chat.write_message': 'Write a message...',
    'search.search_in': 'Search in {name}...',
    'search.search_products': 'Search products...',
    'search.browse_by_category': 'Browse by Category',
    'search.results_count': '{count} results',
    'search.no_results': 'No results',
    'review.rate_driver': 'Rate Driver',
    'review.already_reviewed': 'Already Reviewed',
    'review.already_reviewed_desc': 'You have already reviewed this order',
    'review.thanks': 'Thank you for your review! ⭐',
    'review.add_comment': 'Add a comment (optional)...',
    'review.submitting': 'Submitting...',
    'review.submit': 'Submit Review',
    'review.bad': 'Bad',
    'review.acceptable': 'Fair',
    'review.good': 'Good',
    'review.very_good': 'Very Good',
    'review.excellent': 'Excellent',
    'review.rate_customer': 'Rate Customer',
    'review.comment_placeholder': 'Comment (optional)...',
    'review.sending': 'Sending...',
    'review.send': 'Send Review',
    'review.sent_success': 'Review sent successfully!',
    'admin.services': 'Services',
    'admin.manage_services': 'Manage Services',
    'admin.service_approved': 'Service approved ✅',
    'admin.service_rejected': 'Service rejected ❌',
    'admin.service_disabled': 'Service disabled',
    'admin.service_enabled': 'Service enabled',
    'admin.approved_badge': 'Approved',
    'admin.pending_approval': 'Pending Approval',
    'admin.approve': 'Approve',
    'admin.reject': 'Reject',
    'admin.service_provider': 'Provider',
    'admin.phone_label': 'Phone',
    'admin.city_label': 'City',
    'admin.request_date': 'Request Date',
    'admin.no_pending_services': 'No pending requests',
    'admin.no_services': 'No services',
    'admin.approved_services': 'Approved',
    'admin.store_approved': 'Store approved ✅',
    'admin.store_rejected': 'Store rejected ❌',
    'admin.pending_stores': 'Pending Requests',
    'admin.active_stores': 'Active Stores',
    'admin.no_pending_stores': 'No pending requests',
    'admin.approve_store': 'Approve',
    'admin.reject_store': 'Reject',
    'admin.awaiting_approval': 'Awaiting Approval',
    'admin.role_admin': 'Admin',
    'admin.role_vendor': 'Vendor',
    'admin.role_driver': 'Driver',
    'admin.role_customer': 'Customer',
    'admin.role_add_error': 'Failed to add role',
    'admin.role_remove_error': 'Failed to remove role',
    'admin.role_added': 'Role added',
    'admin.role_removed': 'Role removed',
    'admin.remove_role': 'Remove role',
    'notification.new_order': '🔔 New Order!',
    'notification.new_order_desc': 'New order worth {amount} - #{id}',
    'notification.delivery_confirmed': '✅ Customer confirmed delivery',
    'notification.order_cancelled': '❌ Order cancelled',
    'notification.order_id': 'Order #{id}',
    'product.free_delivery': 'Fast Delivery',
    'product.guarantee': 'Quality Guarantee',
    'product.return_policy': 'Free Returns',
    'profile.admin_panel': 'Admin Panel',
    'service.propose': 'Offer a Service',
    'service.title_label': 'Service Title',
    'service.title_placeholder': 'e.g. Professional plumber for homes',
    'service.category': 'Category',
    'service.choose_category': 'Choose a category',
    'service.description': 'Description',
    'service.description_placeholder': 'Describe your service in detail...',
    'service.images': 'Service Images',
    'service.images_hint': 'You can upload up to 5 images',
    'service.provider_name': 'Your Name',
    'service.provider_name_placeholder': 'Full name or company name',
    'service.phone': 'Phone Number',
    'service.phone_placeholder': '0555 123 456',
    'service.whatsapp': 'WhatsApp Number',
    'service.whatsapp_placeholder': '0555 123 456',
    'service.wilaya': 'Wilaya',
    'service.choose_wilaya': 'Choose wilaya',
    'service.city': 'City / Municipality',
    'service.city_placeholder': 'e.g. Bab El Oued, Oran...',
    'service.address': 'Address',
    'service.address_placeholder': 'Detailed address',
    'service.price_type': 'Pricing Type',
    'service.negotiable': 'On Quote',
    'service.fixed': 'Fixed Price',
    'service.hourly': 'Per Hour',
    'service.price': 'Price (DA)',
    'service.experience': 'Years of Experience',
    'service.experience_placeholder': 'e.g. 5',
    'service.availability': 'Availability',
    'service.available': 'Available',
    'service.busy': 'Busy',
    'service.unavailable': 'Unavailable',
    'service.work_hours': 'Working Hours',
    'service.work_hours_placeholder': 'e.g. 08:00 - 17:00',
    'service.submit': 'Submit Service',
    'service.submitting': 'Submitting...',
    'service.required_fields': 'Please fill in the required fields',
    'service.success': 'Service submitted! It will appear after admin approval.',
    'service.approval_banner': 'Your service will appear after admin approval.',
    'service.pending': 'Pending Approval',
    'service.provider': 'Provider',
    'service.not_found': 'Service not found',
    'service.back': 'Back',
    'service.call': 'Call',
    'service.on_quote': 'On Quote',
    'service.per_hour': '/hr',
    'service.reviews': 'Reviews',
    'service.login_to_review': 'Log in to leave a review',
    'service.login': 'Log in',
    'service.already_reviewed': 'You have already reviewed this service',
    'service.give_review': 'Leave your review',
    'service.your_comment': 'Your comment...',
    'service.send': 'Send',
    'service.sending': 'Sending...',
    'service.review_success': 'Thanks for your review!',
    'service.years_exp': 'years experience',
    'service.distinguished': 'Distinguished craftsman',
    'service.work_schedule': 'Working Hours',
  },
  fr: {
    'app.name': 'Marché DZ',
    'app.welcome': 'Bienvenue 👋',
    'app.search_placeholder': 'Rechercher produits, boutiques...',
    'home.discover': 'Découvrir',
    'home.deliver_to': 'Livrer en Algérie',
    'nav.home': 'Accueil',
    'nav.search': 'Recherche',
    'nav.chat': 'Messages',
    'nav.cart': 'Panier',
    'nav.profile': 'Profil',
    'home.exclusive': 'Offres Exclusives',
    'home.discount_up_to': "Jusqu'à 50% de réduction",
    'home.on_products': 'Sur plus de 1000 produits',
    'home.shop_now': 'Acheter maintenant',
    'home.categories': 'Catégories',
    'home.featured_stores': 'Boutiques en vedette',
    'home.special_offers': '🔥 Offres Spéciales',
    'home.new_arrivals': '✨ Nouveautés',
    'home.best_sellers': '🔥 Meilleures ventes',
    'home.all_products': 'Tous les produits',
    'home.limited': 'Offre limitée',
    'product.add_to_cart': 'Ajouter au panier',
    'product.color': 'Couleur',
    'product.size': 'Taille',
    'product.description': 'Description',
    'product.similar': 'Produits similaires',
    'product.reviews': 'avis',
    'product.not_found': 'Produit introuvable',
    'product.new': 'Nouveau',
    'product.hot': '🔥 Tendance',
    'product.discount': 'Réduction',
    'cart.title': 'Panier',
    'cart.product': 'article',
    'cart.empty': 'Panier vide',
    'cart.empty_desc': 'Commencez à ajouter des produits',
    'cart.browse': 'Parcourir les produits',
    'cart.subtotal': 'Sous-total',
    'cart.delivery': 'Livraison',
    'cart.free': 'Gratuite',
    'cart.total': 'Total',
    'cart.checkout': 'Commander',
    'checkout.title': 'Commande',
    'checkout.address': 'Adresse de livraison',
    'checkout.address_placeholder': 'Entrez votre adresse complète',
    'checkout.phone': 'Numéro de téléphone',
    'checkout.notes': 'Notes (optionnel)',
    'checkout.notes_placeholder': 'Notes spéciales pour la commande...',
    'checkout.coupon': 'Code promo',
    'checkout.coupon_placeholder': 'Entrez le code promo',
    'checkout.apply': 'Appliquer',
    'checkout.remove': 'Supprimer',
    'checkout.coupon_discount': 'Réduction coupon',
    'checkout.payment': 'Mode de paiement',
    'checkout.cod': 'Paiement à la livraison',
    'checkout.summary': 'Résumé de commande',
    'checkout.confirm': 'Confirmer la commande',
    'checkout.submitting': 'Envoi en cours...',
    'checkout.success': 'Commande confirmée !',
    'checkout.order_number': 'Commande #',
    'checkout.will_contact': 'Nous vous contacterons pour confirmer la livraison',
    'checkout.back_home': "Retour à l'accueil",
    'checkout.invalid_coupon': 'Coupon invalide',
    'checkout.check_coupon': 'Vérifiez le code coupon',
    'checkout.expired_coupon': 'Coupon expiré',
    'checkout.used_coupon': 'Coupon entièrement utilisé',
    'checkout.min_order': 'Minimum non atteint',
    'checkout.min_amount': 'Minimum',
    'checkout.coupon_applied': 'Coupon appliqué !',
    'checkout.error': 'Erreur',
    'checkout.order_error': 'Erreur lors de la création de la commande',
    'orders.title': 'Mes Commandes',
    'orders.empty': 'Aucune commande',
    'orders.login_prompt': 'Connectez-vous pour voir vos commandes',
    'orders.rate_driver': 'Évaluer le livreur',
    'orders.rated': '✓ Évalué',
    'orders.status.pending': 'En attente',
    'orders.status.confirmed': 'Confirmée',
    'orders.status.preparing': 'En préparation',
    'orders.status.shipping': 'En livraison',
    'orders.status.delivered': 'Livrée',
    'orders.status.cancelled': 'Annulée',
    'profile.title': 'Mon Compte',
    'profile.user': 'Utilisateur',
    'profile.guest_title': 'Bienvenue',
    'profile.guest_desc': 'Connectez-vous pour profiter de toutes les fonctionnalités',
    'profile.login': 'Se connecter',
    'profile.logout': 'Se déconnecter',
    'profile.orders': 'Mes Commandes',
    'profile.vendor_panel': 'Panneau Vendeur',
    'profile.driver_panel': 'Panneau Livreur',
    'profile.addresses': 'Mes Adresses',
    'profile.settings': 'Paramètres',
    'profile.dark_mode': 'Mode Sombre',
    'profile.light_mode': 'Mode Clair',
    'profile.language': 'Langue',
    'profile.currency': 'Devise',
    // Common
    'common.loading': 'Chargement...',
    'common.error': 'Erreur',
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.add': 'Ajouter',
    'common.edit': 'Modifier',
    'common.delete': 'Supprimer',
    'common.confirm': 'Confirmer',
    'common.added': 'Ajouté',
    'common.updated': 'Mis à jour',
    'common.deleted': 'Supprimé',
    'common.no_data': 'Pas encore de données',
    // Admin
    'admin.panel': 'Panneau Admin',
    'admin.management': 'Gestion',
    'admin.overview': 'Vue d\'ensemble',
    'admin.stores': 'Boutiques',
    'admin.orders': 'Commandes',
    'admin.categories': 'Catégories',
    'admin.users': 'Utilisateurs',
    'admin.drivers': 'Livreurs',
    'admin.reports': 'Rapports',
    'admin.settings': 'Paramètres',
    'admin.stores_count': 'Boutiques',
    'admin.orders_count': 'Commandes',
    'admin.products_count': 'Produits',
    'admin.users_count': 'Utilisateurs',
    'admin.manage_orders': 'Gestion des commandes',
    'admin.all_orders': 'Toutes les commandes',
    'admin.filter': 'Filtrer',
    'admin.no_orders': 'Aucune commande',
    'admin.confirm_order': 'Confirmer',
    'admin.start_preparing': 'Commencer la préparation',
    'admin.send_delivery': 'Envoyer en livraison',
    'admin.mark_delivered': 'Livrée',
    'admin.status_updated': 'Statut de commande mis à jour en',
    'admin.manage_stores': 'Gestion des boutiques',
    'admin.no_stores': 'Aucune boutique enregistrée',
    'admin.verified': 'Vérifié',
    'admin.active': 'Actif',
    'admin.disabled': 'Désactivé',
    'admin.no_description': 'Sans description',
    'admin.join_date': 'Date d\'inscription',
    'admin.disable': 'Désactiver',
    'admin.enable': 'Activer',
    'admin.store_disabled': 'Boutique désactivée',
    'admin.store_enabled': 'Boutique activée',
    'admin.unverify': 'Vérification retirée',
    'admin.verify': 'Boutique vérifiée',
    'admin.store': 'Boutique',
    'admin.no_users': 'Aucun utilisateur',
    'admin.no_name': 'Sans nom',
    'admin.no_phone': 'Sans téléphone',
    'admin.joined': 'Inscrit',
    'admin.customer': 'Client',
    'admin.manage_categories': 'Gestion des catégories',
    'admin.icon_placeholder': 'Icône (emoji)',
    'admin.new_category': 'Nom de la nouvelle catégorie',
    'admin.no_categories': 'Aucune catégorie',
    'admin.manage_drivers': 'Gestion des livreurs',
    'admin.no_drivers': 'Aucun livreur enregistré',
    'admin.delivery_count': 'livraison',
    'admin.activated': 'Activé',
    'admin.suspended': 'Suspendu',
    'admin.driver_disabled': 'Livreur désactivé',
    'admin.driver_enabled': 'Livreur activé',
    'admin.reports_stats': 'Rapports et statistiques',
    'admin.total_revenue': 'Revenu total',
    'admin.total_orders': 'Total des commandes',
    'admin.completed_orders': 'Commandes terminées',
    'admin.delivery_fees': 'Frais de livraison',
    'admin.monthly_sales': 'Ventes mensuelles',
    'admin.order_statuses': 'Statuts des commandes',
    'admin.daily_orders': 'Commandes quotidiennes (30 derniers jours)',
    'admin.performance': 'Résumé des performances',
    'admin.completion_rate': 'Taux de complétion',
    'admin.cancellation_rate': 'Taux d\'annulation',
    'admin.avg_order': 'Valeur moyenne des commandes',
    'admin.print_pdf': 'Imprimer PDF',
    'admin.admin_report': 'Rapport admin',
    'admin.general_settings': 'Paramètres généraux',
    'admin.commissions': 'Commissions',
    'admin.default_commission': 'Commission par défaut (%)',
    'admin.delivery_section': 'Livraison',
    'admin.delivery_fee': 'Frais de livraison',
    'admin.free_delivery_min': 'Minimum livraison gratuite',
    'admin.cod_section': 'Paiement à la livraison',
    'admin.max_cod': 'Valeur maximale de commande',
    'admin.save_settings': 'Enregistrer les paramètres',
    'admin.settings_saved': 'Paramètres enregistrés avec succès',
    'admin.sales': 'Ventes',
    'admin.order_count': 'Nombre de commandes',
    // Vendor
    'vendor.panel': 'Panneau Vendeur',
    'vendor.store_management': 'Gestion de la boutique',
    'vendor.overview': 'Vue d\'ensemble',
    'vendor.products': 'Produits',
    'vendor.orders': 'Commandes',
    'vendor.store': 'Boutique',
    'vendor.chat': 'Messages',
    'vendor.coupons': 'Coupons',
    'vendor.stats': 'Statistiques',
    'vendor.finance': 'Finances',
    'vendor.settings': 'Paramètres',
    'vendor.no_store': 'Aucune boutique créée',
    'vendor.contact_admin': 'Veuillez contacter l\'admin',
    'vendor.under_review': 'Votre boutique est en cours de révision',
    'vendor.will_activate': 'Sera activée après approbation de l\'admin',
    'vendor.total_products': 'Produits',
    'vendor.total_orders': 'Total des commandes',
    'vendor.new_orders': 'Nouvelles commandes',
    'vendor.store_info': 'Infos boutique',
    'vendor.store_name': 'Nom de la boutique',
    'vendor.status': 'Statut',
    'vendor.rating': 'Évaluation',
    'vendor.active': 'Actif',
    'vendor.under_review_badge': 'En révision',
    'vendor.no_store_found': 'Pas de boutique',
    'vendor.confirm_order': 'Confirmer la commande',
    'vendor.start_preparing': 'Commencer la préparation',
    'vendor.ready_ship': 'Prêt à expédier',
    'vendor.status_updated': 'Statut de commande mis à jour',
    'vendor.no_orders': 'Aucune commande',
    'vendor.add_product': 'Ajouter un produit',
    'vendor.edit_product': 'Modifier le produit',
    'vendor.add_new_product': 'Ajouter un nouveau produit',
    'vendor.product_name': 'Nom du produit',
    'vendor.description': 'Description',
    'vendor.product_desc': 'Description du produit',
    'vendor.price': 'Prix',
    'vendor.old_price': 'Ancien prix',
    'vendor.stock': 'Stock',
    'vendor.category': 'Catégorie',
    'vendor.choose': 'Choisir',
    'vendor.product_status': 'Statut',
    'vendor.available': 'Disponible',
    'vendor.out_of_stock': 'Rupture de stock',
    'vendor.hidden': 'Caché',
    'vendor.badge': 'Badge',
    'vendor.none': 'Aucun',
    'vendor.new': 'Nouveau',
    'vendor.sale': 'Promotion',
    'vendor.hot': 'Tendance',
    'vendor.colors': 'Couleurs (séparées par virgule)',
    'vendor.sizes': 'Tailles (séparées par virgule)',
    'vendor.save_changes': 'Enregistrer les modifications',
    'vendor.add_product_btn': 'Ajouter le produit',
    'vendor.no_products': 'Aucun produit',
    'vendor.first_product': 'Ajoutez votre premier produit',
    'vendor.no_description': 'Sans description',
    'vendor.product_deleted': 'Produit supprimé',
    'vendor.store_settings': 'Paramètres de la boutique',
    'vendor.store_description': 'Description de la boutique',
    'vendor.phone': 'Numéro de téléphone',
    'vendor.address': 'Adresse',
    'vendor.saved': 'Modifications enregistrées',
    'vendor.finance_title': 'Finances',
    'vendor.transactions_here': 'L\'historique des transactions apparaîtra ici',
    'vendor.after_first_order': 'Après la première commande',
    'vendor.discount_coupons': 'Coupons de réduction',
    'vendor.add_coupon': 'Ajouter un coupon',
    'vendor.edit_coupon': 'Modifier le coupon',
    'vendor.new_coupon': 'Créer un nouveau coupon',
    'vendor.coupon_code': 'Code coupon',
    'vendor.coupon_desc': 'Description (optionnel)',
    'vendor.discount_type': 'Type de réduction',
    'vendor.percentage': 'Pourcentage %',
    'vendor.fixed_amount': 'Montant fixe',
    'vendor.discount_value': 'Valeur de réduction',
    'vendor.min_order': 'Commande minimum',
    'vendor.max_uses': 'Nombre d\'utilisations',
    'vendor.unlimited': 'Illimité',
    'vendor.expiry_date': 'Date d\'expiration (optionnel)',
    'vendor.create': 'Créer',
    'vendor.update': 'Mettre à jour',
    'vendor.no_coupons': 'Aucun coupon',
    'vendor.coupon_active': 'Actif',
    'vendor.coupon_expired': 'Expiré',
    'vendor.coupon_paused': 'Arrêté',
    'vendor.discount': 'Réduction',
    'vendor.min_order_label': 'Minimum',
    'vendor.usage': 'Utilisation',
    'vendor.expires': 'Expire',
    'vendor.coupon_updated': 'Coupon mis à jour',
    'vendor.coupon_created': 'Coupon créé',
    'vendor.coupon_deleted': 'Coupon supprimé',
    'vendor.code_copied': 'Code copié',
    'vendor.total_revenue': 'Revenu total',
    'vendor.recent_orders': 'Dernières commandes',
    'vendor.no_orders_yet': 'Aucune commande pour le moment',
    'vendor.stock_alerts': 'Alertes de stock',
    'vendor.stock_good': '✅ Le stock est en bon état',
    'vendor.needs_attention': '⚠️ Nécessite votre attention',
    'vendor.out_of_stock_label': 'Épuisé',
    'vendor.remaining': 'restant',
    'vendor.active_orders': 'Commandes actives',
    'vendor.monthly_sales': 'Ventes mensuelles',
    'vendor.order_statuses': 'Statuts des commandes',
    'vendor.daily_orders': 'Commandes quotidiennes (30 derniers jours)',
    'vendor.performance': 'Résumé des performances',
    'vendor.completion_rate': 'Taux de complétion',
    'vendor.cancellation_rate': 'Taux d\'annulation',
    'vendor.avg_order': 'Valeur moyenne',
    'vendor.store_report': 'Rapport boutique',
    'vendor.store_not_found': 'Boutique introuvable',
    'vendor.customer_chats': 'Messages clients',
    'vendor.customer': 'Client',
    'vendor.settings_extra': 'Paramètres supplémentaires bientôt',
    'vendor.sales': 'Ventes',
    'vendor.order_count': 'Nombre de commandes',
    'vendor.search_orders': '🔍 Rechercher par n° commande ou téléphone...',
    'vendor.processing': 'En traitement',
    'vendor.in_transit': 'En route',
    'vendor.completed': 'Terminées',
    'vendor.no_processing_orders': 'Aucune commande en traitement',
    'vendor.no_transit_orders': 'Aucune commande en route',
    'vendor.no_completed_orders': 'Aucune commande terminée',
    'vendor.awaiting_confirmation': '⏳ En attente de confirmation du client',
    'vendor.rate_customer': 'Évaluer le client',
    'vendor.customer_rated': '✓ Client évalué',
    'vendor.hide_products': 'Masquer les produits',
    'vendor.show_products': 'Voir les produits commandés',
    'vendor.product_item': 'Produit',
    'vendor.quantity': 'Qté',
    'vendor.size_label': 'Taille',
    'vendor.color_label': 'Couleur',
    'vendor.uploading': 'Téléchargement...',
    'vendor.no_results': 'Aucun résultat',
    'vendor.search_products': '🔍 Rechercher des produits...',
    'orders.confirm_delivery': 'Confirmer la réception',
    'orders.confirming': 'Confirmation...',
    'orders.confirm_title': 'Confirmer la réception',
    'orders.confirm_desc': 'Confirmez-vous la réception de la commande #{id} ? Cette action est irréversible.',
    'orders.confirmed_success': '✅ Réception confirmée',
    'orders.confirmed_desc': 'Merci pour votre confirmation',
    'orders.yes_received': 'Oui, reçu',
    'auth.login_title': 'Bon retour 👋',
    'auth.login_subtitle': 'Connectez-vous pour continuer',
    'auth.email': 'E-mail',
    'auth.password': 'Mot de passe',
    'auth.forgot_password': 'Mot de passe oublié ?',
    'auth.remember_me': 'Se souvenir de moi',
    'auth.logging_in': 'Connexion...',
    'auth.login': 'Se connecter',
    'auth.no_account': 'Pas encore de compte ?',
    'auth.create_account': 'Créer un compte',
    'auth.login_error': 'Erreur de connexion',
    'auth.register_title': 'Créer un nouveau compte ✨',
    'auth.register_subtitle': 'Inscrivez-vous et commencez vos achats',
    'auth.full_name': 'Nom complet',
    'auth.password_hint': 'Mot de passe (6 caractères minimum)',
    'auth.creating_account': 'Création du compte...',
    'auth.register': 'Créer un compte',
    'auth.have_account': 'Déjà un compte ?',
    'auth.register_error': 'Erreur d\'inscription',
    'auth.register_success': 'Inscription réussie !',
    'auth.verify_email': 'Veuillez vérifier votre e-mail pour confirmer votre compte',
    'auth.password_min': 'Le mot de passe doit contenir au moins 6 caractères',
    'auth.forgot_title': 'Réinitialiser le mot de passe 🔑',
    'auth.forgot_subtitle': 'Entrez votre e-mail et nous vous enverrons un lien de réinitialisation',
    'auth.forgot_phone_subtitle': 'Entrez votre numéro de téléphone et nous vous enverrons un code de vérification',
    'auth.via_email': 'Par e-mail',
    'auth.via_phone': 'Par téléphone',
    'auth.phone_number': 'Numéro de téléphone',
    'auth.send_otp': 'Envoyer le code',
    'auth.otp_sent': 'Code envoyé',
    'auth.check_phone': 'Vérifiez vos messages',
    'auth.enter_otp': 'Entrez le code de vérification',
    'auth.verify_otp': 'Vérifier le code',
    'auth.verifying': 'Vérification...',
    'auth.otp_verified': 'Vérifié avec succès !',
    'auth.invalid_otp': 'Code de vérification invalide',
    'auth.sending': 'Envoi...',
    'auth.send_reset': 'Envoyer le lien',
    'auth.back_to_login': 'Retour à la connexion',
    'auth.reset_sent': 'Lien envoyé',
    'auth.check_email': 'Vérifiez votre e-mail',
    'auth.reset_title': 'Nouveau mot de passe 🔐',
    'auth.reset_subtitle': 'Entrez votre nouveau mot de passe',
    'auth.new_password': 'Nouveau mot de passe',
    'auth.updating': 'Mise à jour...',
    'auth.update_password': 'Mettre à jour',
    'auth.password_updated': 'Mot de passe mis à jour avec succès !',
    'chat.title': 'Messages',
    'chat.login_prompt': 'Connectez-vous pour voir vos messages',
    'chat.no_conversations': 'Aucune conversation',
    'chat.store': 'Boutique',
    'chat.customer': 'Client',
    'chat.new_conversation': 'Nouvelle conversation',
    'chat.start_conversation': 'Démarrer la conversation...',
    'chat.write_message': 'Écrire un message...',
    'search.search_in': 'Rechercher dans {name}...',
    'search.search_products': 'Rechercher des produits...',
    'search.browse_by_category': 'Parcourir par catégorie',
    'search.results_count': '{count} résultats',
    'search.no_results': 'Aucun résultat',
    'review.rate_driver': 'Évaluer le livreur',
    'review.already_reviewed': 'Déjà évalué',
    'review.already_reviewed_desc': 'Vous avez déjà évalué cette commande',
    'review.thanks': 'Merci pour votre avis ! ⭐',
    'review.add_comment': 'Ajouter un commentaire (optionnel)...',
    'review.submitting': 'Envoi...',
    'review.submit': 'Envoyer l\'avis',
    'review.bad': 'Mauvais',
    'review.acceptable': 'Passable',
    'review.good': 'Bien',
    'review.very_good': 'Très bien',
    'review.excellent': 'Excellent',
    'review.rate_customer': 'Évaluer le client',
    'review.comment_placeholder': 'Commentaire (optionnel)...',
    'review.sending': 'Envoi...',
    'review.send': 'Envoyer l\'avis',
    'review.sent_success': 'Avis envoyé avec succès !',
    'admin.services': 'Services',
    'admin.manage_services': 'Gestion des services',
    'admin.service_approved': 'Service approuvé ✅',
    'admin.service_rejected': 'Service refusé ❌',
    'admin.service_disabled': 'Service désactivé',
    'admin.service_enabled': 'Service activé',
    'admin.approved_badge': 'Approuvé',
    'admin.pending_approval': 'En attente',
    'admin.approve': 'Approuver',
    'admin.reject': 'Refuser',
    'admin.service_provider': 'Prestataire',
    'admin.phone_label': 'Téléphone',
    'admin.city_label': 'Ville',
    'admin.request_date': 'Date de demande',
    'admin.no_pending_services': 'Aucune demande en attente',
    'admin.no_services': 'Aucun service',
    'admin.approved_services': 'Approuvés',
    'admin.store_approved': 'Boutique approuvée ✅',
    'admin.store_rejected': 'Boutique refusée ❌',
    'admin.pending_stores': 'Demandes en attente',
    'admin.active_stores': 'Boutiques actives',
    'admin.no_pending_stores': 'Aucune demande en attente',
    'admin.approve_store': 'Approuver',
    'admin.reject_store': 'Refuser',
    'admin.awaiting_approval': 'En attente d\'approbation',
    'admin.role_admin': 'Admin',
    'admin.role_vendor': 'Vendeur',
    'admin.role_driver': 'Livreur',
    'admin.role_customer': 'Client',
    'admin.role_add_error': 'Échec de l\'ajout du rôle',
    'admin.role_remove_error': 'Échec de la suppression du rôle',
    'admin.role_added': 'Rôle ajouté',
    'admin.role_removed': 'Rôle supprimé',
    'admin.remove_role': 'Supprimer le rôle',
    'notification.new_order': '🔔 Nouvelle commande !',
    'notification.new_order_desc': 'Nouvelle commande de {amount} - #{id}',
    'notification.delivery_confirmed': '✅ Le client a confirmé la réception',
    'notification.order_cancelled': '❌ Commande annulée',
    'notification.order_id': 'Commande #{id}',
    'product.free_delivery': 'Livraison rapide',
    'product.guarantee': 'Qualité garantie',
    'product.return_policy': 'Retour gratuit',
    'profile.admin_panel': 'Panneau admin',
    'service.propose': 'Proposer un service',
    'service.title_label': 'Titre du service',
    'service.title_placeholder': 'Ex: Plombier professionnel à domicile',
    'service.category': 'Catégorie',
    'service.choose_category': 'Choisir une catégorie',
    'service.description': 'Description',
    'service.description_placeholder': 'Décrivez votre service en détail...',
    'service.images': 'Photos du service',
    'service.images_hint': 'Vous pouvez télécharger jusqu\'à 5 photos',
    'service.provider_name': 'Votre nom',
    'service.provider_name_placeholder': 'Nom complet ou nom de l\'entreprise',
    'service.phone': 'Téléphone',
    'service.phone_placeholder': '0555 123 456',
    'service.whatsapp': 'Numéro WhatsApp',
    'service.whatsapp_placeholder': '0555 123 456',
    'service.wilaya': 'Wilaya',
    'service.choose_wilaya': 'Choisir la wilaya',
    'service.city': 'Ville / Commune',
    'service.city_placeholder': 'Ex: Bab El Oued, Oran...',
    'service.address': 'Adresse',
    'service.address_placeholder': 'Adresse détaillée',
    'service.price_type': 'Type de tarif',
    'service.negotiable': 'Sur devis',
    'service.fixed': 'Prix fixe',
    'service.hourly': 'Par heure',
    'service.price': 'Prix (DA)',
    'service.experience': 'Années d\'expérience',
    'service.experience_placeholder': 'Ex: 5',
    'service.availability': 'Disponibilité',
    'service.available': 'Disponible',
    'service.busy': 'Occupé',
    'service.unavailable': 'Indisponible',
    'service.work_hours': 'Horaires de travail',
    'service.work_hours_placeholder': 'Ex: 08:00 - 17:00',
    'service.submit': 'Soumettre le service',
    'service.submitting': 'Envoi en cours...',
    'service.required_fields': 'Veuillez remplir les champs obligatoires',
    'service.success': 'Service soumis ! Il apparaîtra après approbation.',
    'service.approval_banner': 'Votre service sera visible après approbation.',
    'service.pending': 'En attente d\'approbation',
    'service.provider': 'Prestataire',
    'service.not_found': 'Service introuvable',
    'service.back': 'Retour',
    'service.call': 'Appeler',
    'service.on_quote': 'Sur devis',
    'service.per_hour': '/h',
    'service.reviews': 'Avis',
    'service.login_to_review': 'Connectez-vous pour laisser un avis',
    'service.login': 'Se connecter',
    'service.already_reviewed': 'Vous avez déjà évalué ce service',
    'service.give_review': 'Donnez votre avis',
    'service.your_comment': 'Votre commentaire...',
    'service.send': 'Envoyer',
    'service.sending': 'Envoi...',
    'service.review_success': 'Merci pour votre avis !',
    'service.years_exp': 'ans d\'expérience',
    'service.distinguished': 'Artisan distingué',
    'service.work_schedule': 'Horaires de travail',
  },
};

// Driver translations - inject into each language
const driverTranslations: Record<Language, Record<string, string>> = {
  ar: {
    'driver.home': 'الرئيسية',
    'driver.orders': 'الطلبات',
    'driver.tracking': 'التتبع',
    'driver.profile': 'حسابي',
    'driver.dashboard': 'لوحة المندوب',
    'driver.welcome': 'أهلاً {name} 👋',
    'driver.delivery_agent': 'مندوب توصيل',
    'driver.available': 'متاح',
    'driver.unavailable': 'غير متاح',
    'driver.active_order': 'طلب نشط',
    'driver.delivered': 'تم التسليم',
    'driver.rating': 'التقييم',
    'driver.active_orders': 'طلبات نشطة',
    'driver.with_driver': 'مع المندوب',
    'driver.no_active_orders': 'لا توجد طلبات نشطة حالياً',
    'driver.browse_available': 'تصفح الطلبات المتاحة لقبولها',
    'driver.awaiting_approval': 'بانتظار الموافقة',
    'driver.awaiting_approval_title': 'بانتظار الموافقة',
    'driver.awaiting_approval_desc': 'حسابك قيد المراجعة، سيتم تفعيله قريباً',
    'driver.available_orders': 'الطلبات المتاحة',
    'driver.no_available_orders': 'لا توجد طلبات متاحة حالياً',
    'driver.auto_refresh': 'سيتم تحديث القائمة تلقائياً',
    'driver.accept_order': 'قبول الطلب',
    'driver.delivery_fee': 'توصيل',
    'driver.order_accepted': 'تم قبول الطلب!',
    'driver.order_accepted_desc': 'يمكنك تتبعه في صفحة التتبع',
    'driver.order_accept_error': 'لم يتم قبول الطلب، ربما قبله مندوب آخر',
    'driver.delivery_tracking': 'تتبع التوصيل',
    'driver.connected': 'متصل',
    'driver.no_tracking_orders': 'لا توجد طلبات نشطة للتتبع',
    'driver.accept_from_available': 'اقبل طلباً من صفحة الطلبات المتاحة',
    'driver.call_customer': 'اتصل بالعميل',
    'driver.mark_delivered': 'تم التسليم',
    'driver.delivered_success': 'تم التسليم بنجاح! ✅',
    'driver.my_account': 'حسابي',
    'driver.phone': 'رقم الهاتف',
    'driver.vehicle': 'المركبة',
    'driver.motorcycle': '🏍️ دراجة نارية',
    'driver.car': '🚗 سيارة',
    'driver.bicycle': '🚲 دراجة هوائية',
    'driver.customer_reviews': 'تقييمات العملاء',
    'driver.no_reviews': 'لا توجد تقييمات بعد',
    'driver.activated': 'مفعّل',
    'driver.sign_out': 'تسجيل الخروج',
    'driver.error': 'خطأ',
  },
  en: {
    'driver.home': 'Home',
    'driver.orders': 'Orders',
    'driver.tracking': 'Tracking',
    'driver.profile': 'Profile',
    'driver.dashboard': 'Driver Dashboard',
    'driver.welcome': 'Hello {name} 👋',
    'driver.delivery_agent': 'Delivery Agent',
    'driver.available': 'Available',
    'driver.unavailable': 'Unavailable',
    'driver.active_order': 'Active Order',
    'driver.delivered': 'Delivered',
    'driver.rating': 'Rating',
    'driver.active_orders': 'Active Orders',
    'driver.with_driver': 'With Driver',
    'driver.no_active_orders': 'No active orders right now',
    'driver.browse_available': 'Browse available orders to accept',
    'driver.awaiting_approval': 'Pending Approval',
    'driver.awaiting_approval_title': 'Awaiting Approval',
    'driver.awaiting_approval_desc': 'Your account is under review and will be activated soon',
    'driver.available_orders': 'Available Orders',
    'driver.no_available_orders': 'No available orders right now',
    'driver.auto_refresh': 'The list will refresh automatically',
    'driver.accept_order': 'Accept Order',
    'driver.delivery_fee': 'delivery',
    'driver.order_accepted': 'Order Accepted!',
    'driver.order_accepted_desc': 'You can track it on the tracking page',
    'driver.order_accept_error': 'Could not accept order, another driver may have taken it',
    'driver.delivery_tracking': 'Delivery Tracking',
    'driver.connected': 'Connected',
    'driver.no_tracking_orders': 'No active orders to track',
    'driver.accept_from_available': 'Accept an order from the available orders page',
    'driver.call_customer': 'Call Customer',
    'driver.mark_delivered': 'Delivered',
    'driver.delivered_success': 'Delivered successfully! ✅',
    'driver.my_account': 'My Account',
    'driver.phone': 'Phone Number',
    'driver.vehicle': 'Vehicle',
    'driver.motorcycle': '🏍️ Motorcycle',
    'driver.car': '🚗 Car',
    'driver.bicycle': '🚲 Bicycle',
    'driver.customer_reviews': 'Customer Reviews',
    'driver.no_reviews': 'No reviews yet',
    'driver.activated': 'Active',
    'driver.sign_out': 'Sign Out',
    'driver.error': 'Error',
  },
  fr: {
    'driver.home': 'Accueil',
    'driver.orders': 'Commandes',
    'driver.tracking': 'Suivi',
    'driver.profile': 'Mon compte',
    'driver.dashboard': 'Tableau de bord livreur',
    'driver.welcome': 'Bonjour {name} 👋',
    'driver.delivery_agent': 'Agent de livraison',
    'driver.available': 'Disponible',
    'driver.unavailable': 'Indisponible',
    'driver.active_order': 'Commande active',
    'driver.delivered': 'Livrée',
    'driver.rating': 'Note',
    'driver.active_orders': 'Commandes actives',
    'driver.with_driver': 'Avec le livreur',
    'driver.no_active_orders': 'Aucune commande active pour le moment',
    'driver.browse_available': 'Parcourez les commandes disponibles pour en accepter',
    'driver.awaiting_approval': 'En attente',
    'driver.awaiting_approval_title': 'En attente d\'approbation',
    'driver.awaiting_approval_desc': 'Votre compte est en cours de vérification et sera activé bientôt',
    'driver.available_orders': 'Commandes disponibles',
    'driver.no_available_orders': 'Aucune commande disponible pour le moment',
    'driver.auto_refresh': 'La liste se met à jour automatiquement',
    'driver.accept_order': 'Accepter',
    'driver.delivery_fee': 'livraison',
    'driver.order_accepted': 'Commande acceptée !',
    'driver.order_accepted_desc': 'Vous pouvez la suivre sur la page de suivi',
    'driver.order_accept_error': 'Impossible d\'accepter, un autre livreur l\'a peut-être prise',
    'driver.delivery_tracking': 'Suivi de livraison',
    'driver.connected': 'Connecté',
    'driver.no_tracking_orders': 'Aucune commande active à suivre',
    'driver.accept_from_available': 'Acceptez une commande depuis la page des commandes disponibles',
    'driver.call_customer': 'Appeler le client',
    'driver.mark_delivered': 'Livrée',
    'driver.delivered_success': 'Livraison réussie ! ✅',
    'driver.my_account': 'Mon compte',
    'driver.phone': 'Numéro de téléphone',
    'driver.vehicle': 'Véhicule',
    'driver.motorcycle': '🏍️ Moto',
    'driver.car': '🚗 Voiture',
    'driver.bicycle': '🚲 Vélo',
    'driver.customer_reviews': 'Avis des clients',
    'driver.no_reviews': 'Aucun avis pour le moment',
    'driver.activated': 'Activé',
    'driver.sign_out': 'Déconnexion',
    'driver.error': 'Erreur',
  },
};

// Merge driver translations
Object.keys(driverTranslations).forEach((lang) => {
  Object.assign(translations[lang as Language], driverTranslations[lang as Language]);
});

export const languageNames: Record<Language, string> = {
  ar: 'العربية',
  en: 'English',
  fr: 'Français',
};
